import { render, staticRenderFns } from "./Bmzd.vue?vue&type=template&id=b36f8150&"
import script from "./Bmzd.vue?vue&type=script&lang=js&"
export * from "./Bmzd.vue?vue&type=script&lang=js&"
import style0 from "./Bmzd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports